export default __webpack_public_path__ + "locales/bg/EmptyTrashDialog.json?hash=f7bff0c52fdc907444cfa0e25044f497";